import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Reports from './Reports';
import SingleComponent from './SingleComponent';
import Spinner from 'react-spinkit';
import SupersetDemo from "./SupersetDemo/SupersetDemo";

const AppContainer = styled.div`
  font-family: latoregular;
  display: grid;
  min-width: 0;
  min-height: 0;
  width: 100vw;
  height: 100vh;
  grid-template-rows: auto 1fr;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    'header header'
    'sidebar content';
  ${props =>
    props.presentable
      ? `overflow: auto;`
      : `position: relative; overflow: hidden;`};
`;

const AppContainerSpinner = styled.div`
  display: ${props => (props.visible ? 'grid' : 'none')};
  align-items: center;
  justify-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: white;
  color: black;
  text-align: center;
  z-index: 1;
`;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { apiEndpoint } = this.props.appInfo;
    fetch(`${apiEndpoint}user`, {
      credentials: 'include'
    })
      .then(response => {
        if (response.redirected) {
          const nextUrl = window.location.href.replace(window.location.origin, '');
          const redirectUrl = (nextUrl == '/') ? `login` : `/login?next=${encodeURIComponent(nextUrl)}`;

          window.location.replace(redirectUrl);
          return {}
        }
        return response.json();
      })
      .then(({ id, email, reports, show_version_switcher }) => {
        this.setState({ id, email, reports, show_version_switcher });
      });
  }

  render() {
    const selfProps = this.props;
    const selfState = this.state;
    return (
      <AppContainer presentable={this.state.reports}>
        <AppContainerSpinner visible={!this.state.reports}>
          <Spinner name="ball-grid-pulse" color="#2cc4f4" />
        </AppContainerSpinner>
        {!!this.state.reports && (
          <Switch>
            <Redirect exact from={`/`} to={`/reports`} />
            <Route
              path={`/components`}
              render={props => (
                <SingleComponent
                  {...props}
                  apiEndpoint={selfProps.appInfo.apiEndpoint}
                />
              )}
            />
            <Route
              path={`/reports`}
              render={props => (
                <Reports
                  {...props}
                  reports={selfState.reports}
                  apiEndpoint={selfProps.appInfo.apiEndpoint}
                  versionSwitcher={selfState.show_version_switcher}
                />
              )}
            />
          </Switch>
        )}
      </AppContainer>
    );
  }
}

export default App;
